module.exports = __webpack_public_path__ + "static/media/p5_5.7abb6d95.jpeg";